module.exports = __webpack_public_path__ + "img/procura-logo-white.33fce1cd.webp";